import { render } from "./MovieSource.vue?vue&type=template&id=afcb4750"
import script from "./MovieSource.vue?vue&type=script&lang=js"
export * from "./MovieSource.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__